import React, { useContext } from 'react'
import { useRouter } from 'next/navigation'
import AuthContext from '../../context/AuthContext'
import useCompanySubscription from '../../hooks/queries/useCompanySubscription'

type Props = {
	callToAction?: () => void
}

const BillingAlert = ({ callToAction }: Props) => {
	const authContext = useContext(AuthContext)
	const router = useRouter()
	const { companySubscription, isLoading } = useCompanySubscription()

	const onPress = () => {
		if (callToAction) {
			callToAction()
		}
		router.push('/dashboard/billing')
	}

	return (
		<>
			{!isLoading && !companySubscription && (
				<div className="p-4 mb-4 text-sm text-start text-black bg-red-200 rounded-lg" role="alert">
					{authContext.isCompanyManager ? (
						<>
							<p>Start by setting up billing for the company.</p>
							<div className="flex mt-4">
								<button
									className="flex items-center bg-hitemup-green rounded text-white text-sm font-bold px-3 py-1 border-2 border-transparent hover:border-green-700 mr-4"
									onClick={onPress}
								>
									Open billing
								</button>
							</div>
						</>
					) : (
						<p>Contact your administrator to set up billing</p>
					)}
				</div>
			)}
		</>
	)
}

export default BillingAlert
